<template>
    <div class="body-pergunta">
        <b-modal ref="deleteQuestion"
        size="md"
        centered
        title="-"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem "
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">Confirmar Exclusão</div>
        </template>
            <div class="container-exc-pergunta">
                <div><i class="fas fa-trash icone"></i></div>
                <div class="label">Deseja excluir esses itens selecionados?</div>

                <div class="d-flex container_cancel_save">
                      <div class="cancelar">
                          <button class="button-cancel">NÃO</button>
                      </div>
                      <div class="criar" v-if="subGrupo === true">
                          <button class="button-save" v-if="OrientacaoId === null" @click="deleteItem">SIM</button>
                          <button class="button-save" v-if="OrientacaoId !== null" @click="deleteItemOrientacao">SIM</button>
                      </div>
                      <button class="button-save" v-if="OrientacaoId !== null" @click="deleteItemOrientacao">SIM</button>
                      <button class="button-save" v-if="orientacao === true" @click="deleteOrientacao">SIM</button>
                      <button class="button-save" v-if="cabecalho === true" @click="deleteCabecalho">SIM</button>
                      <button class="button-save" v-if="assinatura === true" @click="deleteAssinatura">SIM</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import deleteQuestion from './deleteQuestion'
export default deleteQuestion
</script>
  <style scoped>
  .icone{
    font-size: 40px;
    margin: 1rem;
    color: #008148;
  }
  .container-exc-pergunta{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .body-pergunta {
    width: 100%;
  }
  .label {
    font: normal normal 600 16px / 24px Segoe UI;
  }
  .header-title {
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .input-descricao{
      width: 100%;
      margin-top: 0.5rem;
      height: 2rem;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 17px;
      margin-bottom: 1rem;
  }
  .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 3rem;
    column-gap: 20px;
   }
   .button-cancel{
     background-color: #b60000;
     color: white;
   }
   .button-save{
    background-color: darkgreen;
    color: white;
   }

  .button-cancel,
  .button-save{
    margin-top: 10;
    font: normal normal 600 12px / 24px Segoe UI;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/deleteQuestion/deleteQuestion.vue